import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-navbar-one',
    templateUrl: './navbar-one.component.html',
    styleUrls: ['./navbar-one.component.scss'],
    standalone: false
})
export class NavbarOneComponent {

}
